export const locale = {
    lang: 'fr',
    data: {
        TEAM: 'Discussion d\'équipe',
        CONVERSATION: 'Engager une conversation en tapant votre message ci-dessous.',
        TYPE: 'Tapez votre message',
        ANIMATOR_BADGE: 'Animateur'
    }
};
